<template>
    <div>
        <div v-if="handsFreeText" class="bg-gray2 mt-1">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12 pt-1">
                        <p class="d-flex align-items-center mb-0">
                            <span
                                aria-hidden="true"
                                class="item-icon icon-hands-free font-size-24 pr-1"
                            />
                            <strong v-html="handsFreeText" />
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-gray2">
            <div class="container-fluid px-lg-0">
                <div id="mentions" class="row bg-gray2 pt-1">
                    <div class="col-12 px-lg-2 pb-2">
                        <button
                            v-if="legalMentionsTitle"
                            id="mention"
                            type="button"
                            class="o-link-arrow down text-left"
                            data-toggle="collapse"
                            aria-expanded="true"
                            data-target="#collapsed-text"
                            aria-controls="#collapsed-text"
                            v-html="legalMentionsTitle"
                        />
                        <div
                            v-if="legalMentionsText"
                            id="collapsed-text"
                            class="collapse show font-size-resp-12"
                            aria-labelledby="mention"
                        >
                            <div v-html="legalMentionsText" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "InternetAndMobileLegalMentions",
    components: {},
    props: {
        legalMentionsTitle: {
            type: String,
            required: true
        },
        legalMentionsText: {
            type: String,
            required: false,
            default: undefined
        },
        handsFreeText: {
            type: String,
            required: false,
            default: undefined
        },
    },
    data() {
        return {
        }
    },
    computed: {
    }
}
</script>

<style scoped lang="scss">
</style>
